import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';
import { LoginButton } from './component/buttonkeycloak';
import { Helmet } from 'react-helmet-async';
import { Grid } from '@mui/material';
import { LogoutButton } from './component/buttonkeycloak';
import { getToken, getRole } from 'src/utils/common';
import { useNavigate } from 'react-router-dom';
import { getAcl, ListMenu } from 'src/utils/common';

export default function LoadingPage() {
  const navigate = useNavigate();
  const token = getToken();
  const role = getRole();

  useEffect(() => {
    if (sessionStorage.getItem('token') == 'undefined' || sessionStorage.getItem('token') == null) {
      sessionStorage.clear();
      navigate('/login', { replace: true });
    }
    // if ()
    const ListMenus = ListMenu() || [];
    setTimeout(() => {
      const acl = JSON.parse(getAcl() || '[]'); // Fallback to an empty array if getAcl() returns null
      const newMenu = [];
      ListMenus.map((c) => {
        const menu = acl?.find((e) => c.namaroute === e.nama_menu && e.read === true);
        if (menu) {
          newMenu.push(c);
          return;
        }
      });
      navigate(newMenu[0].path, { replace: true }); // Redirect to the appropriate route
    }, 5000);
  }, [role, navigate]);

  return (
    <>
      <Helmet>
        <title> SmartShield </title>
      </Helmet>
      <Grid
        xs={12}
        item
        md={6}
        style={{
          // backgroundColor: '',
          backgroundImage: 'url(/assets/Signup.png)',
          backgroundSize: 'cover', // Adjust this as needed
          backgroundPosition: 'absolute', // Adjust this as needed
          height: '100vh',
          zIndex: '1',
        }}
      >
        {''}
        {role === 'norole' || token === 'gada' ? (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-100" />

              <div className="text-center mb-3">
                <Typography variant="h2" align="center" style={{ color: '#00000' }}>
                  Welcome to <span style={{ color: '#1dbcee' }}>SMART</span>
                  <span style={{ color: '#21386d' }}>SHIELD</span>
                </Typography>
                <Typography variant="h3" align="center" style={{ color: '#00000', paddingBottom: '30px' }}>
                  You don't have access to SmartShield, please contact the administrator.
                </Typography>
                <div style={{ paddingTop: '30px' }}> {token ? <LogoutButton /> : ''}</div>

                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0"></div>
          </div>
        ) : (
          <div className="relative z-100 container mx-auto px-4 h-full">
            <div className="relative flex content-center items-center justify-center h-full">
              <img src="/assets/smartshild.png" alt="smartshield Logo" className="w-100" />

              <div className="text-center mb-3">
                <Typography variant="h2" align="center" style={{ color: '#00000' }}>
                  Welcome to <span style={{ color: '#1dbcee' }}>SMART</span>
                  <span style={{ color: '#21386d' }}>SHIELD</span>
                </Typography>
                <div className="w-full">
                  <Typography variant="h6" align="center" style={{ color: '#21386d', paddingTop: '30px' }}>
                    {' '}
                    &copy; 2024 ChainSmart - All Rights Reserved
                  </Typography>
                  <div style={{ opacity: 0, pointerEvents: 'none' }}>
                    <LoginButton />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: '100%' }} className="flex-auto px-4 lg:px-10 py-10 pt-0"></div>
          </div>
        )}
      </Grid>
    </>
  );
}
